import dedent from 'dedent';

import CodeHighlight from 'dashboard/components-lib/CodeHighlight';
import { Environment } from 'dashboard/models/environment';
import { InquiryTemplate } from 'dashboard/models/inquiry-template';
import { Template } from 'dashboard/models/template';
import { Label } from 'design-system/components/Text';
import { ApiModel } from 'lib/interfaces/api';

/**
 * Update this whenever a new stable version of the JS SDK is released.
 */
const JS_SDK_SOURCE = 'https://cdn.withpersona.com/dist/persona-v5.1.2.js';
/**
 * Whenever updating the above, put the new URL into srihash.org to generate an integrity hash.
 * For more information, see https://developer.mozilla.org/en-US/docs/Web/Security/Subresource_Integrity
 */
const SRI_HASH = 'sha384-nuMfOsYXMwp5L13VJicJkSs8tObai/UtHEOg3f7tQuFWU5j6LAewJbjbF5ZkfoDo';

interface EmbeddedCodeSnippetProps {
  id?: string;
  template: Template | InquiryTemplate;
  environment: Environment;
}

const EmbeddedCodeSnippet = ({ id, template, environment }: EmbeddedCodeSnippetProps) => {
  return (
    <div>
      <Label size='md' weight='bold'>
        Embedded flow code sample
        {environment.type === ApiModel.EnvironmentSandbox ? ' (Sandbox)' : ''}
      </Label>
      <CodeHighlight id={id}>
        {dedent`
          <script src="${JS_SDK_SOURCE}" integrity="${SRI_HASH}" crossorigin="anonymous"></script>
          <script>
            const client = new Persona.Client({
              templateId: '${template.id}',
              environmentId: '${environment.id}',
              onReady: () => client.open(),
              onComplete: ({ inquiryId, status, fields }) => {
                console.log(\`Completed inquiry ${'${inquiryId}'} with status ${'${status}'}\`);
              }
            });
          </script>
        `}
      </CodeHighlight>
    </div>
  );
};

export default EmbeddedCodeSnippet;
